/** Logical UDO template keys; populated when this capability adopts UDO storage. */
export enum OttopilotWebhooksWorkspaceCapabilityUdoTemplateKey {}
